"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chatTranslations = {
    emptyChatMessage: "No Record found",
    emptyDirectory: "Empty Directory",
    chatLoadingMessage: "Loading Chats",
    messages: "MESSAGES",
    directory: "DIRECTORY",
    alert: "ALERTS",
    patient: "PATIENTS",
    direct: "DIRECT",
    internalGroups: "INTERNAL",
    broadcasts: "BROADCASTS",
    hiddenGroups: "HIDDEN",
    NoUserFound: "No user found",
    NoGroupFound: "No group found",
    header: {
        unreadLabel: "unread",
        results: "results",
        patients: "Patients",
        internalGroups: "Internal Groups",
        directMessages: "Direct Messages",
        broadcastGroups: "Broadcasts",
        hiddenGroups: "Hidden Groups",
        clinicianStaff: "Clinician/Staff",
        physicians: "Physicians",
    },
    alerts: {
        priority: "Priority",
        acknowledge: "Acknowledge",
        referral: "Referral",
        starred: "Starred",
        starredMessages: "Starred Messages",
        pendingReferrals: "Pending Referrals",
        alertsLoadingMessage: "Loading Alerts",
        noPriorityAlerts: "No new priority alerts",
        noReadPriorityAlerts: "No recently read priority alerts",
        noPendingAcknowledgmentAlerts: "No pending acknowledgement alerts",
        noSentAcknowledgmentAlerts: "No sent acknowledgment alerts",
        noReadAcknowledgementAlerts: "No recently read acknowledgment alerts",
        noAcknowledgedAlerts: "No recently acknowledged alerts",
        noPendingReferrals: "No pending referrals",
        noStarredMessages: "No starred messages",
    },
    acknowledgeType: {
        pending: "Pending",
        sent: "Sent",
    },
    searchPlaceholder: "Search",
    search: "Search",
    groupDeletedToast: "This group has been deleted",
    patientChatDetails: {
        more: "More",
        less: "Less",
    },
    referral: {
        reminder: "Reminder",
        referralInviteText: "Referral Invite",
        setReminderFor: "set reminder for",
        referralResponseSuggestion: "Set this reminder again or revoke this referral",
        reminderOptions: {
            fifteenMin: "15 min",
            oneHour: "1 Hr",
            eightHours: "8 Hrs",
            twentyFourHours: "24 Hrs",
            revokeReferral: "Revoke",
            remind: "Remind",
        },
    },
    askForAcknowledgement: {
        askForAcknowledgementHeader: "Ask for Acknowledgement",
        sendBtn: "Send",
        noRecipient: "No user left to ask for acknowledgement",
        noneSelected: "Select who should acknowledge",
    },
    messageInfo: {
        messageInfoHeader: "Message Info",
        messageReadStatus: "Read",
        messageSentStatus: "Sent",
        messageDeliveredStatus: "Delivered",
        messageStatusListHeader: "Read/Delivered Status",
        messagePendingStatus: "Pending",
        originallySentBy: "Originally Sent By",
        in: "in",
        sending: "Sending",
    },
    forwardTo: {
        forwardToHeader: "Forward to",
        forwardBtn: "Forward",
        noneSelected: "Select who to forward to",
        noContactsFound: "No contacts found",
        searchToForward: "Search for a chat to forward to",
        searchToForwardHint: "Start typing a name to find who you want to send this to",
        searchByNameOrMrn: "Search by name or MRN",
        searchToForwardHintMrn: "Start typing a name or MRN to find who you want to send this to",
        loadingContacts: "Loading contacts...",
        messagesSelected: "{{totalMessagesSelected}} selected",
        forwardSuccess: "Message(s) forwarded successfully",
        forwardError: "Failed to forward message(s)",
        forwarding: "Forwarding...",
        forwardUnconfirmed: "Couldn't confirm the forward. Check the chat before trying again.",
        forwardUnconfirmedOnReturn_one: "A forward to 1 chat was never confirmed. Check it before sending again.",
        forwardUnconfirmedOnReturn_other: "A forward to {{count}} chats was never confirmed. Check them before sending again.",
    },
    share: {
        title: "Share to",
        shareBtn: "Share",
        noneSelected: "Select who to share with",
        noFilesShared: "No files to share",
        loading: "Loading share intent...",
        goBack: "Go back",
        goBackConfirmTitle: "Discard selection?",
        goBackConfirmMessage: "Going back will unselect all chosen groups. Are you sure?",
        goBackConfirmYes: "Discard",
        shareError: "Failed to share. Please try again.",
        shareUnconfirmed: "We could not confirm these files were sent. They are still selected — try again once you are back online.",
    },
    userStatus: {
        online: "Online",
        offline: "Offline",
        lastSeen: "Last seen",
        lastSeenSecAgo: "Last seen few sec ago",
        yesterday: "Yesterday",
        today: "Today",
        ago: "ago",
        fewSecAgo: "few sec ago",
    },
    timeUnit: {
        year: "year",
        month: "month",
        week: "week",
        day: "day",
        hour: "hour",
        minute: "minute",
        second: "second",
        years: "years",
        months: "months",
        weeks: "weeks",
        days: "days",
        hours: "hours",
        minutes: "minutes",
        seconds: "seconds",
    },
    templates: {
        selectTemplate: "Select Template",
        noTemplates: "No Templates Available",
        noForm: "No form found for this template",
        selectRole: "Select any one option",
        emptyFormError: "Please provide a value for at least one of the fields",
        appointmentConflict: "There is a conflict with your selected date and time",
        scheduledVisitsOn: "Scheduled Visits ({{date}})",
        viewScheduledVisits: "View scheduled visits",
        noScheduledVisits: "No visits scheduled on this day",
        submitUnconfirmed: "We could not confirm this form was submitted. Check the chat before filling it in again.",
    },
};
exports.default = chatTranslations;
